export default function ProductWordmark({ dark = false, compact = false }: {
  dark?: boolean;
  compact?: boolean;
}) {
  return <span className={`inline-flex flex-wrap items-baseline gap-x-2 ${compact ? 'text-lg' : 'text-xl'}`} style={{ fontFamily: 'Inter, system-ui, sans-serif' }} aria-label="NALVRA SERVICE">
    <span className="font-light tracking-[0.16em]" style={{ color: dark ? '#FFFFFF' : '#0B0D10' }}>NALVRA</span>
    <span className="font-semibold tracking-[0.12em]" style={{ color: '#5AAEFF' }}>SERVICE</span>
  </span>;
}
